import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { SsoSetupServiceImpl } from "~/backend/generated/SSOSetup/api/ssoSetup.service";
import type { TokenExchangeRequestBody } from "~/backend/generated/SSOSetup/model/tokenExchangeRequestBody";
import { RefreshTokenResponse, RefreshTokenParams } from "./types";

export const refreshToken =
    (ctx: ContextManager) =>
    async (options: RefreshTokenParams): Promise<RefreshTokenResponse> => {
        const ssoSetupService = ctx.retrieveInstanceOf(ContextInstance.SsoSetupServiceImpl, SsoSetupServiceImpl);
        const requestBody: TokenExchangeRequestBody = {
            refreshToken: options.refreshToken,
            ssoProfileSid: options.ssoProfileSid,
            appType: options.appType,
            accountSid: options.accountSid,
            instanceSid: options.instanceSid,
            isConsoleLogin: options.isConsoleLogin,
            grantType: "RefreshToken"
        };

        return ssoSetupService.generateOauthTokens(requestBody);
    };
